<template>
  <div class="resetPwd">
    <!-- 设置密码 -->
    <div class="content_wrap">
        <div class="content" ref='minContent'>
            <!-- 身份验证 -->
            <div class="part_one" ref="part_one">
                <div class="track">
                    <img src="../assets/img/resetPwd/5-1.png">
                </div>
                <form class="form_group" @submit.prevent="validateSubmitOne('form-1')" data-vv-scope="form-1">
                    <div class="input_group">
                        <icon name="mobile" class="icon"></icon>
                        <input type="tel" name="phone" v-model="phone" placeholder="请输入手机号" v-validate="'required|phone'" :class="{'input': true, 'is-danger': errors.has('phone') }" @input="phoneChange">
                    </div>
                    <span v-show="errors.has('form-1.phone')" class="help is-danger">{{ errors.first('form-1.phone') }}</span>
                    <div class="jisu"></div>
                    <div class="input_group">
                        <icon name="envelope-open-o" class="icon"></icon>
                        <input type="text" id="codeVal" ref="code" name="code" v-model="code" placeholder="请填写手机验证码" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('code') }">
                        <button class="sendCode" type="button" ref="getCode" :disabled='canGet' @click="countDown()">获取验证码</button>
                    </div>
                    <span v-show="errors.has('form-1.code')" class="help is-danger">{{ errors.first('form-1.code') }}</span>
                    <div class="nextPart">
                        <button type="submit" class="previous">下一步</button>
                    </div>
                </form>
            </div>
            <!-- 设置密码 -->
            <div class="part_two" ref="part_two">
                <div class="track">
                    <img src="../assets/img/resetPwd/5-2.png">
                </div>
                <!-- 表单部分 -->
                <form class="form_group" @submit.prevent="validateSubmitTwo('form-2')" data-vv-scope="form-2">
                    <div class="input_group">
                        <icon name="lock" class="icon"></icon>
                        <input type="password" ref='pw' name="password"  v-model="password" placeholder="请输入新密码" v-validate="'required|min:6|max:16'" :class="{'input': true, 'is-danger': errors.has('password') }">
                        <icon name="eye" class="look" :class="{'lookType':!lookType}" @click.native="seePw()"></icon>
                    </div>
                    <span v-show="errors.has('form-2.password')" class="help is-danger">{{ errors.first('form-2.password') }}</span>
                    <div class="input_group">
                        <icon name="lock" class="icon"></icon>
                        <input type="password" name="newpasswordAgain" v-model="passwordAgain" placeholder="请输入新密码" v-validate="'required|confirmed:password'" :class="{'input': true, 'is-danger': errors.has('newpasswordAgain') }">
                    </div>
                    <span v-show="errors.has('form-2.newpasswordAgain')" class="help is-danger">{{ errors.first('form-2.newpasswordAgain') }}</span>                    
                    <div class="nextPart">
                        <button type='submit' class="previous">下一步</button>
                    </div>
                </form>
            </div>
            <!-- 完成 -->
            <div class="part_three" ref="part_three">
                <div class="track">
					<img src="../assets/img/resetPwd/5-3.png"/>
				</div>
                <div class="success">
                    <img src="../assets/img/resetPwd/pic.png">
                    <p>恭喜您，新密码设置成功</p>
                </div>
                <div class="nextPart">
                    <button type="button" class="success_btn" @click="tologin()">立即登录</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Geetest from '../assets/js/gt'
import { Toast } from 'mint-ui'
var captcha = null
export default {
  name: 'resetPwd',
  data () {
    return {
      phone: '',
      code: '',
      time: '60',
      canGet: 'true',
      password: '',
      passwordAgain: '',
      lookType: 'false',
      tmpGeetest: Geetest
    }
  },
  mounted () {
    this.initGeetested()
    this.STATE.state.bottomindex='btnFive'
  },
  methods: {
    initGeetested () {
      var _this = this
      this.axios.get('/url/common/fastRegister?t=' + (new Date()).getTime())
      .then(function (data) {
        window.initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captcha = captchaObj
          captchaObj.onReady(function () {
            console.log('onReady==========')
          }).onSuccess(function () {
            var result = captchaObj.getValidate()
            if (result) {
              _this.getCodeFromBack(result)
            } else {
              alert('验证失败')
            }
          })
        })
      })
    },
    getCodeFromBack: function (result) {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/common/getWechatVerificationCode/3',
        params: {
          moblie: this.phone,
          challenge: result.geetest_challenge,
          validate: result.geetest_validate,
          seccode: result.geetest_seccode
        }
      }).then(function (response) {
        let msg = ''
        if (response.data.success) {
          msg = '发送成功'
          _this.runCode()
        } else {
          msg = response.data.msg
        }
        Toast({
          message: msg,
          position: 'middle',
          duration: 1000
        })
      }).catch(function (response) {
        Toast({
          message: '发送失败',
          position: 'middle',
          duration: 1000
        })
      })
    },
    runCode: function () {
      if (this.time === 0) {
        this.$refs.getCode.removeAttribute('disabled')
        this.$refs.getCode.innerHTML = '获取验证码'
        this.time = 60
      } else {
        this.$refs.getCode.setAttribute('disabled', true)
        this.$refs.getCode.innerHTML = this.time + '秒后获取'
        this.time --
        setTimeout(this.runCode, 1000)
      }
    },
    validateSubmitOne (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var _this = this
          this.axios({
            method: 'post',
            url: '/url/updatepwd/checkVerificationCode/3',
            params: {
              moblie: this.phone,
              message: this.code
            }
          }).then(function (response) {
            let msg = '出现异常'
            if (response.data.success) {
              // _this.$refs.minContent.style.animation = 'nextPage 0.5s linear forwards'
              // _this.$refs.minContent.style.WebkitAnimation = 'nextPage 0.5s linear forwards'
              _this.$refs.part_one.style.display="none"
              _this.$refs.part_three.style.display="none"
              _this.$refs.part_two.style.display=""
            } else {
              msg = response.data.msg
              Toast({
                message: msg,
                position: 'middle',
                duration: 1000
              })
            }
          }).catch(function (response) {
            Toast({
              message: '校验失败',
              position: 'middle',
              duration: 1000
            })
          })
        }
      })
    },
    countDown: function () {
      captcha.verify()
    },
    phoneChange: function () {
      var reg = /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      var bol = reg.test(this.phone)
      if (bol) {
        this.canGet = false
      } else {
        this.canGet = true
      }
    },
    validateSubmitTwo (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var _this = this
          this.axios({
            method: 'post',
            url: '/url/updatepwd/updatepwd',
            params: {
              pwdmoblie: this.phone,
              password: this.password,
              pwdmessages: this.code
            }
          }).then(function (response) {
            let msg = '出现异常'
            if (response.data.success) {
              // _this.$refs.minContent.style.animation = 'nextPage2 0.5s linear forwards'
              // _this.$refs.minContent.style.WebkitAnimation = 'nextPage2 0.5s linear forwards'
              _this.$refs.part_one.style.display="none"
              _this.$refs.part_two.style.display="none"
              _this.$refs.part_three.style.display=""
            } else {
              msg = response.data.msg
              Toast({
                message: msg,
                position: 'middle',
                duration: 1000
              })
            }
          }).catch(function (response) {
            Toast({
              message: '修改失败',
              position: 'middle',
              duration: 1000
            })
          })
        }
      })
    },
    seePw () {
      if (this.$refs.pw.type === 'password') {
        this.$refs.pw.type = 'text'
        this.lookType = false
      } else {
        this.$refs.pw.type = 'password'
        this.lookType = true
      }
    },
    tologin () {
      this.$router.push({path: '/passport/login'})
    },
  }
}
</script>

<style scoped>
  .content_wrap{
    width:100%;
    height:100%;
    overflow:hidden;
    margin-bottom:80px;
  }
  .content{
    width:400%;
    height:100%;
    position:relative;
    overflow:hidden;
    animation-fill-mode:forwards;
    -webkit-animation-fill-mode:forwards;
  }
  .part_one,.part_two,.part_three{
    width: 25%;
    float: left;
  }
  .track{
      width: 80%;
      margin: 40px auto;
  }
  .track img{
      width: 100%;
  }
  .form_group{
      padding: 0 10%;
  }
  .input_group{
      line-height: 40px;
      margin: 5px 0;
      border-bottom: 1px solid #d9dedf;
  }
  .input_group .icon{
      margin: 0 5px;
      color: #7f8b98;
  }
  .input_group input{
      margin-left: 10px;
      outline:none;
      width: 75%;
      border: none;
  }
  #codeVal{
      width: 50%;
      margin-left: 0;
  }
  .sendCode{
      color:#fff;
      background-color: #108ee9;
      border: none;
      outline: none;
      height: 30px;
      border-radius: 5px;
      -webkit-border-radius:5px;
      -moz-border-radius:5px;
      float: right;
      margin-top: 5px;
  }
  .nextPart button{
      width: 100%;
      line-height: 40px;
      font-size: 16px;
      border-radius: 20px;
      -webkit-border-radius:20px;
      -moz-border-radius:20px;
      border: none;
      outline: none;
      padding: 0;
      color: #fff;
      background-color: #108ee9;
      margin-top:30px;
  }
  .look{
      color: #7f8b98;
  }
  .input_group input::-webkit-input-placeholder{
    color: #b7c3ca;
  }
  .input_group input:-moz-placeholder{
  　color:#b7c3ca;
  }
  .input_group input::-moz-placeholder{
  　color:#b7c3ca;
  }
  .input_group input:-ms-input-placeholder{
  　color:#b7c3ca;
  }
  .help{
      display: block;
      width: 80%;
      margin: 0 auto;
      font-size: 14px;
      color: red;
  }
  .success{
      width: 80%;
      margin: 0 auto;
      text-align: center;
  }
  .success img{
      width: 60%;
      height: auto;
  }
  .success p{
      color:#006fff;
      margin-top:30px;
  }
  .success_btn{
      display: block;
      width: 80%!important;
      margin: 0 auto;
  }
  .lookType{
  color:#108ee9!important;
  }
  /* @-webkit-keyframes "nextPage"{
	0%{
		left:0;
		}
	100%{left:-100%;}
  }
  @keyframes "nextPage"{
	0%{
		left:0;
		}
	100%{left:-100%;}
  }
  @-webkit-keyframes "nextPage2"{
	0%{
		left:-100%;
		}
	100%{left:-200%;}
  }
  @keyframes "nextPage2"{
	0%{
		left:100%;
		}
	100%{left:-200%;}
  } */
</style>



// WEBPACK FOOTER //
// resetPwd.vue?d0ede9e4